export default __webpack_public_path__ + "static/jose-gonzalez-e5b90ab3069c63fa4f571098b7c24171.jpg";